import { InteractionRequiredAuthError, InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { Paths } from "src/constants";

const useAccessToken = () => {
  const { instance, inProgress } = useMsal();

  async function getAccessToken() {
    const account = instance.getActiveAccount();

    if (!account) {
      throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    try {
      const response = await instance.acquireTokenSilent({
        account: account,
        scopes: ["api://0d84e22a-e1f3-4a40-9e92-cf70356a1cc9/access_as_user"],
        redirectUri: Paths.Redirect,
      });

      return response.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError && inProgress === InteractionStatus.None) {
        try {
          await instance.acquireTokenRedirect({
            account: account,
            scopes: ["api://0d84e22a-e1f3-4a40-9e92-cf70356a1cc9/access_as_user"],
            redirectUri: Paths.Redirect,
          });
        } catch (error) {
          throw error;
        }
      }

      throw error;
    }
  }

  return {
    getAccessToken,
  };
};

export { useAccessToken };
